import css from "styled-jsx/css";

export default css`
  .buttons {
    display: flex;
    margin-top: 28px;
    margin-bottom: 24px;
  }
`;
